import swg from './src/controllers/swg';
import {forceSWGLogout} from './src/controllers/user';
import {version} from './package.json'

module.exports = {
  init : function (){
    window.GoogleSubscribe = window.GoogleSubscribe || new swg();
    console.log(`Registracion Runtime: ${version}`);
  },
  forceSWGLogout : forceSWGLogout
}


// WEBPACK FOOTER //
// ./~/@ln/registracionlibs/app.js